import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ReservationSuccess() {
    const navigate = useNavigate();

    const goToReservations = () => {
        const userId = localStorage.getItem('userId');
        const ownerId = localStorage.getItem('ownerId');
        const role = localStorage.getItem('role');

        if (role === 'owner' && ownerId) {
            navigate(`/owner-panel/${ownerId}`);
        } else if (role === 'user' && userId) {
            navigate(`/profile/${userId}`);
        } else {
            // Eğer login değilse login sayfasına yönlendir
            navigate('/login');
        }
    };

    return (
        <section className="relative w-full min-h-screen">
            {/* Background Image */}
            <img
                src="https://cdn.pixabay.com/photo/2020/06/25/10/21/architecture-5339245_1280.jpg"
                alt="background"
                className="absolute inset-0 w-full h-full object-cover brightness-50"
            />

            <div className="relative z-10 flex items-center justify-center min-h-screen px-4 py-10">
                <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl max-w-md w-full p-8 flex flex-col items-center text-center">

                    {/* Tick icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-20 w-20 text-green-400 mb-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>

                    {/* Text */}
                    <h2 className="text-white text-2xl font-bold mb-6">
                        Rezervasyonunuz Başarıyla Oluşturuldu!
                    </h2>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                        <button
                            onClick={goToReservations}
                            className="flex-1 py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-[#7F6B52] to-[#989A79] hover:from-[#989A79] hover:to-[#7F6B52] shadow-md hover:shadow-lg transition-all duration-300"
                        >
                            Rezervasyonlarıma Git
                        </button>
                        <button
                            onClick={() => navigate('/')}
                            className="flex-1 py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-[#7F6B52] to-[#989A79] hover:from-[#989A79] hover:to-[#7F6B52] shadow-md hover:shadow-lg transition-all duration-300"
                        >
                            Ana Menüye Dön
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}